The details of the position opening to be deleted.
